function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys1 = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys1 = ownKeys1.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys1.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import AdvertiserInfoDialog from "./dialog.vue";
import { checkAdvertiserIsExist, fetchAdvertiserInfo } from "@/api/advertiser/manage";
import { defineComponent, computed, reactive, ref, watch, getCurrentInstance } from "vue";
import { AdvertiserAccountType } from "@/common/permission";
export default defineComponent({
    components: {
        AdvertiserInfoDialog: AdvertiserInfoDialog
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var verifyEmailInfo = function verifyEmailInfo() {
            checkAdvertiserIsExist({
                type: "email",
                value: model.value.email
            }).then(function(res) {
                if (Number(res.data.data.exists)) {
                    model.value = _objectSpreadProps(_objectSpread({}, model.value), {
                        exists: Number(res.data.data.exists)
                    });
                    // 获取账号中心的用户信息
                    if (Number(res.data.data.exists) === 2) {
                        fetchAdvertiserInfo({
                            email: model.value.email,
                            is_acs: 1
                        }).then(function(val) {
                            if (val.data.data) {
                                advertiserInfo = val.data.data;
                                showCompany.value = true;
                                model.value.company_name = val.data.data.company_name;
                            }
                        }).catch(function() {
                            showCompany.value = false;
                            isError.value = true;
                        });
                    }
                    isError.value = false;
                } else {
                    throw new Error(" not found");
                }
            }).catch(function() {
                showCompany.value = false;
                isError.value = true;
            });
        };
        var reset = function reset() {
            var _$ref;
            (_$ref = schemaForm.value) === null || _$ref === void 0 ? void 0 : _$ref.resetFields();
            showCompany.value = false;
            isError.value = false;
            model.value.exists = 0;
            model.value.company_name = "";
        };
        var instance = getCurrentInstance();
        var root = instance === null || instance === void 0 ? void 0 : instance.proxy;
        var store = root.$store;
        var schemaForm = ref();
        var showCompany = ref(false);
        var isFocusing = ref(false);
        var isError = ref(false);
        var formConfig = reactive({
            labelPosition: "left",
            labelWidth: "100px"
        });
        var model = ref({
            email: "",
            exists: 0,
            company_name: ""
        });
        var verifyDialog = computed(function() {
            return store.state.advertiser.verifyDialog;
        });
        var schema = computed(function() {
            var validateEmail = function(rule, value, callback) {
                isError.value = true;
                model.value.exists = 0;
                model.value.company_name = "";
                showCompany.value = false;
                var regular = /^[^\s]*$/;
                // ss 使用 yiminghe async-validator 邮箱校验正则修改
                // eslint-disable-next-line
                var emailReg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                if (value.trim() === "") {
                    callback(new Error("\u8BF7\u8F93\u5165\u90AE\u7BB1"));
                } else if (!regular.test(value)) {
                    callback(new Error("\u4E0D\u652F\u6301\u8F93\u5165\u7A7A\u683C"));
                } else if (!emailReg.test(value)) {
                    callback(new Error("\u8BF7\u8F93\u5165\u6B63\u786E\u683C\u5F0F\u90AE\u7BB1"));
                } else {
                    verifyEmailInfo();
                }
            };
            var resultItems = {};
            if (showCompany.value) {
                resultItems = {
                    company_name: {
                        label: "\u516C\u53F8\u540D\u79F0: ",
                        component: "plain-text"
                    }
                };
            }
            return {
                type: "object",
                properties: _objectSpread({
                    email: {
                        label: "\u8BF7\u8F93\u5165\u90AE\u7BB1:",
                        component: "input",
                        rules: [
                            {
                                required: true,
                                message: "\u8BF7\u8F93\u5165\u90AE\u7BB1",
                                trigger: "blur"
                            },
                            {
                                required: true,
                                validator: validateEmail,
                                trigger: "blur"
                            }, 
                        ],
                        field: {
                            type: "input",
                            listeners: {
                                focus: function() {
                                    isFocusing.value = true;
                                },
                                blur: function() {
                                    isFocusing.value = false;
                                }
                            }
                        }
                    }
                }, resultItems)
            };
        });
        var getAdvertiserInfo = function() {
            return {
                company_address: "",
                company_name: "",
                contact_num: "",
                contact: "",
                organization: "",
                country: "",
                currency: 1,
                email: "",
                id: 0,
                is_inner_account: false,
                name: "",
                parent_id: 0,
                timezone: ""
            };
        };
        var advertiserInfo = getAdvertiserInfo();
        var handleClose = function() {
            store.dispatch("advertiser/closeVerifyDialog");
        };
        var handleNextStep = function() {
            store.dispatch("advertiser/openDialog", {
                exists: model.value.exists
            });
            store.dispatch("advertiser/resetInfo");
            var currency = 0;
            if (String(advertiserInfo.currency) === "USD") {
                currency = 1;
            } else if (String(advertiserInfo.currency) === "CNY") {
                currency = 2;
            } else {
                currency = 0;
            }
            // 存储账号中心广告主名称
            if (model.value.exists === 2) {
                store.dispatch("advertiser/updateAdvertiserName", advertiserInfo.name);
            }
            if (model.value.exists === 3) {
                advertiserInfo = getAdvertiserInfo();
                currency = 1;
            }
            var addInfo = {
                id: "",
                basic: _objectSpreadProps(_objectSpread({}, store.state.advertiser.info.basic), {
                    email: model.value.email,
                    company_address: advertiserInfo.company_address,
                    contact_num: advertiserInfo.contact_num,
                    contact: advertiserInfo.contact,
                    organization: advertiserInfo.organization,
                    country: advertiserInfo.country,
                    mws_account_type: advertiserInfo.is_inner_account ? AdvertiserAccountType.Internal : AdvertiserAccountType.Normal,
                    name: advertiserInfo.name,
                    timezone: String(advertiserInfo.timezone)
                }),
                expand: _objectSpreadProps(_objectSpread({}, store.state.advertiser.info.expand), {
                    currency: currency
                }),
                invoices: {}
            };
            addInfo.invoices = [
                {
                    name: "",
                    company: "",
                    address: "",
                    readonly: false
                }, 
            ];
            store.dispatch("advertiser/updateInfo", addInfo);
            handleClose();
        };
        watch(function() {
            return verifyDialog.value.visible;
        }, function(val) {
            if (val) {
                reset();
            }
        });
        return {
            model: model,
            schema: schema,
            isError: isError,
            schemaForm: schemaForm,
            formConfig: formConfig,
            verifyDialog: verifyDialog,
            isFocusing: isFocusing,
            handleClose: handleClose,
            handleNextStep: handleNextStep
        };
    }
});
